import { Component, Input } from "@angular/core";


@Component({
    selector: 'app-presentation',
    templateUrl: 'presentation.component.html',
})
export class PresentationComponent {

    @Input() details: [{value: any, label: any}];
    @Input() css: {wrapper: string, item: string};

    constructor() {

    }


}


// WEBPACK FOOTER //
// /home/debian/git/lea/lea-front/src/app/shared/presentation/presentation.component.ts